import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/exc.academy/components/aboutUs/banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/exc.academy/components/aboutUs/Empowering-futures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/exc.academy/components/aboutUs/Learning.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/exc.academy/components/aboutUs/mission.tsx");
